import { render, staticRenderFns } from "./SliderDemo.vue?vue&type=template&id=c5e0310e&scoped=true&"
import script from "./SliderDemo.vue?vue&type=script&lang=js&"
export * from "./SliderDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e0310e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCardText,VSlider})
